import { useEffect } from 'react';

import { useAuth } from '@/features/auth/api/queries.ts';
import { useProfilesData } from '@/features/user';
import { postToHost, setWebviewMode } from '@/lib/webview-bridge';
import { Spinner } from '@/ui/spinner';

export const ProtectedRouteWv = ({
  children,
}: {
  children: React.ReactNode;
}) => {
  // Enable webview mode only when a webview (`-wv`) route actually mounts.
  // This must NOT be a module-level side effect: router.tsx imports this
  // file eagerly at startup, so a top-level call flips webview mode on for
  // every user — even in a normal browser — which makes handleLogout take
  // the webview branch and skip the redirect to the login page.
  useEffect(() => {
    setWebviewMode(true);
  }, []);

  const { isLoggingIn } = useAuth();
  const { isError, isFetching, selectedProfileId, shouldShowOnboarding } =
    useProfilesData();

  const isUnusableSession =
    !isLoggingIn &&
    !isFetching &&
    (isError || !selectedProfileId || shouldShowOnboarding);

  useEffect(() => {
    if (isUnusableSession) {
      postToHost({ type: 'AUTH_REQUIRED' });
    }
  }, [isUnusableSession]);

  if (isLoggingIn || isFetching) {
    return <Spinner fullPage />;
  }

  if (isUnusableSession) {
    return null;
  }

  return children;
};
